import * as translator from "../../../../utils/translator";
import { RevealTiming, revealStyle } from "../../../../components/Reveal/RevealWords";
import DashedArrow from "../../../../components/DashedArrow/DashedArrow";

interface CarePlusWhatsNextProps {
    language?: string;
}

const STEP_NUMBERS = [1, 2, 3];
const ACTIVE_STEP = 3;

// Same beats as the WL3 start screen: each step fades in, then its arrow draws down to the next one.
const STEP_REVEAL: { avatar: RevealTiming; text: RevealTiming; arrow?: RevealTiming }[] = [
    { avatar: { start: 625, duration: 313 }, text: { start: 688, duration: 400 }, arrow: { start: 1150, duration: 750 } },
    { avatar: { start: 1875, duration: 313 }, text: { start: 1938, duration: 400 }, arrow: { start: 2400, duration: 500 } },
    { avatar: { start: 2900, duration: 312 }, text: { start: 2987, duration: 400 } },
];

const DoneAvatar = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <rect width="24" height="24" rx="12" fill="url(#care-plus-step-done)" />
        <path d="M16.886 8.388a.857.857 0 0 1 .011 1.213l-5.893 6a.857.857 0 0 1-1.223 0l-2.678-2.728a.857.857 0 1 1 1.223-1.2l2.067 2.104 5.281-5.378a.857.857 0 0 1 1.212-.011Z" fill="white" />
        <defs>
            <linearGradient id="care-plus-step-done" x1="27.8" y1="4.8" x2="1.8" y2="23.6" gradientUnits="userSpaceOnUse">
                <stop stopColor="#FFB909" />
                <stop offset="1" stopColor="#E17200" />
            </linearGradient>
        </defs>
    </svg>
);

const ActiveAvatar = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <rect x="0.43" y="0.43" width="23.14" height="23.14" rx="11.57" fill="white" stroke="url(#care-plus-step-active)" strokeWidth="0.86" />
        <circle cx="12" cy="12" r="6" fill="url(#care-plus-step-active)" />
        <defs>
            <linearGradient id="care-plus-step-active" x1="0" y1="12" x2="19.7" y2="12.1" gradientUnits="userSpaceOnUse">
                <stop stopColor="#E07409" />
                <stop offset="1" stopColor="#FFA44E" />
            </linearGradient>
        </defs>
    </svg>
);


export default function CarePlusWhatsNext({ language }: CarePlusWhatsNextProps) {

    return (
        <div className="care-plus-whats-next">
            <span className="care-plus-badge">
                {translator.translate(language, "thankyou", "page/care_plus_whats_next_badge")}
            </span>
            <div className="care-plus-steps">
                {STEP_NUMBERS.map((stepNumber, i) => (
                    <div key={stepNumber} className="care-plus-step" data-active={stepNumber === ACTIVE_STEP || undefined}>
                        <div className="care-plus-step-avatar reveal-fade" style={revealStyle(STEP_REVEAL[i].avatar)}>
                            {stepNumber === ACTIVE_STEP ? <ActiveAvatar /> : <DoneAvatar />}
                        </div>
                        {STEP_REVEAL[i].arrow && (
                            // Same arrow as the WL3 start screen steps.
                            <DashedArrow className="care-plus-step-arrow reveal-draw-down" style={revealStyle(STEP_REVEAL[i].arrow as RevealTiming)} />
                        )}
                        <div className="care-plus-step-text reveal-fade" style={revealStyle(STEP_REVEAL[i].text)}>
                            <p className="care-plus-step-title">
                                {(translator.translate(language, "thankyou", "page/care_plus_step_label") || "").replace(":n", String(stepNumber))}
                            </p>
                            <p className="care-plus-step-content">
                                {translator.translate(language, "thankyou", `page/care_plus_step${stepNumber}_content`)}
                            </p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}
